<template>
  <v-layout column>
    <v-layout>
      <top-info-panel >
        <v-flex xs12 md12 lg6 xl5 px-2  slot="content" >
            <h4>Beheer u geo zone types</h4>
            <p>U kunt uw aangemaakte geozones beter groeperen door deze een type toe te wijzen </p>
        
        </v-flex>
      </top-info-panel>
    </v-layout>
    <v-layout wrap px-3 align-center justify-center class="inset">
       
      <v-flex xs12 md12 lg6 xl5 pt-2>          
          <v-widget title="Geozonetypes beheren" class="" title-text-color="">
            <v-btn fab dark  color="accent" slot="button-top-right" @click="newGeoZoneType()" v-if="!selectedGeoZoneType">
                <v-icon dark>add</v-icon>
            </v-btn>  
            <v-layout slot="widget-content">                                                        
              <v-layout row wrap slot="content">
                  <v-flex xs12 sm12 lg12 v-if="!selectedGeoZoneType">
                    <v-card-text>
                    <v-list dense> 
                      <v-list-tile active-class="primary darken-2" @click="loadForm(type)" avatar v-for="type of geoZoneTypes" :key="type.id">
                          <v-list-tile-avatar> <i class="fas fa-cubes fa-1x primary--text text--lighten-2"></i>  </v-list-tile-avatar>                                                
                          <v-list-tile-title>
                            <v-flex xs12 d-flex justify-space-between wrap>
                              <v-flex xs8>
                                <label>{{type.name}}</label>
                                <label><i> ({{type.geoZones.length}} geozones)</i></label>           
                              </v-flex>         
                              <v-spacer></v-spacer>
                              <v-flex xs3 v-if="type.protected" style="color:orange" >Niet aanpasbaar</v-flex>                                                         
                            </v-flex>
                          </v-list-tile-title>
                      </v-list-tile>                  
                    </v-list>                
                    </v-card-text>
                  </v-flex>
                  <v-flex  v-if="selectedGeoZoneType" px-3 py-3> 
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >
                    <v-flex>                                    
                      <v-text-field                    
                        v-model="selectedGeoZoneType.name"                     
                        label="Naam"
                        :rules="nameRules"
                        required
                      ></v-text-field>
                      </v-flex>
                      <v-flex row >                  
                        <v-layout >
                          <v-btn                          
                              color="info"                      
                              @click="clearCurrent"> 
                              annuleren
                            </v-btn>                                                                                                         
                            <v-spacer></v-spacer>
                            <v-btn                                                
                              color="error"
                              :disabled="!selectedCanBeDeleted"
                              > 
                              Verwijder
                            </v-btn>                                           
                            <v-btn                                                
                              :disabled="!valid || selectedGeoZoneType.protected"
                              color="success"
                              @click="saveForm">
                              Opslaan
                            </v-btn>                        
                        </v-layout>                                                                    
                      </v-flex>                 
                    </v-form>
                    <v-flex xs12 style="margin-top:40px;" v-if="selectedHasGeoZones">
                        <h5>{{selectedGeoZoneType.name}} geozones</h5>
                        <v-flex style="border-top:1px solid #76818D;" >
                          <v-expansion-panel>
                            <v-expansion-panel-content  v-for="zone of selectedGeoZoneType.geoZones" :key="zone.id">
                              <template slot="header">
                                <div>{{zone.name}}</div>                            
                              </template>
                              <v-card xs12>    
                                  <v-flex pa-2>
                                    <v-layout row wrap>
                                      <v-flex xs6>
                                          <div class="dd-label">Naam</div>
                                          <div class="dd-value">{{zone.name}}</div>
                                      </v-flex>          
                                      <v-flex xs6>
                                          <div class="dd-label">Opmerkingen</div>
                                          <div class="dd-value">{{zone.description}}</div>
                                      </v-flex>                                                                        
                                    </v-layout>
                                    <v-layout row mt-2>
                                      <v-flex xs6>
                                          <div class="dd-label">Oppervlakte</div>
                                          <div class="dd-value">{{geoJsonSquareMeasureHumanReadable(zone.squareMeters)}}</div>
                                      </v-flex>
                                      <v-flex xs6>
                                          <div class="dd-label">Omtrek</div>
                                          <div class="dd-value">{{geojsonLineDistanceHumanReadable(zone.perimeterMeters)}}</div>
                                      </v-flex>
                                    </v-layout>      
                                  </v-flex>                                                                                        
                              </v-card>
                            </v-expansion-panel-content>                                                    
                          </v-expansion-panel>
                        </v-flex>
                    </v-flex>
                  </v-flex>                  
                </v-layout>    
              </v-layout>                            
          </v-widget>          
        </v-flex>
    </v-layout>  
  </v-layout>
  
</template>
<script>

import * as types from "../../store/types"
import { mapGetters } from 'vuex'
import TopInfoPanel from "../../components/global/TopInfoPanel"
import VWidget from "../../components/global/VWidget"
import DdPage from '../../components/global/DdPage'
import MapMixin from '../../plugins/mixins/MapMixin'

export default {
  components: {
    VWidget,
    DdPage,
    TopInfoPanel
  },
  data() {
    return  {
      valid:true,
      selectedGeoZoneType:{},
      nameRules:[
        v => !!v || "Naam is verplicht"
      ]
    }
  },
  mixins:[ MapMixin ],  
  computed: {
    ...mapGetters({
      geoZoneTypes: types.GEO_ZONE_TYPES
    }),
    selectedCanBeDeleted(){
        return ( !this.selectedHasGeoZones && this.selectedGeoZoneType.id ) ? true : false
    },
    selectedHasGeoZones(){
        return (this.selectedGeoZoneType.geoZones && this.selectedGeoZoneType.geoZones.length>0) ? true : false;
    }
  },
  methods: {
    saveForm(){
      if (this.$refs.form.validate()) {

          this.$store.dispatch(types.SAVE_GEO_ZONE_TYPE, {data:this.selectedGeoZoneType} ).then((res) => {                            
              this.loadGeoZoneTypes();                              
              this.clearCurrent();
          });
      }
    },
    loadForm(geoZoneType){
        let selectedType={}
        Object.assign(selectedType, geoZoneType)
        this.selectedGeoZoneType = selectedType
    },

    clearCurrent(){
      this.selectedGeoZoneType = null    
    },
    newGeoZoneType(){
      this.selectedGeoZoneType  = {id:"",
                                   name:""}  
    },
    loadGeoZoneTypes(){
        this.$store.dispatch(types.GEO_ZONE_TYPES,{params:{include:"geoZones"}})
    }
  },
  mounted() {
    this.clearCurrent();
    this.loadGeoZoneTypes()

    this.$store.dispatch(types.CURRENT_BREADCRUMBS, [
      {text: 'Home', href: '/', disabled: false},
      {text: 'Instellingen', href: '/settings', disabled: false},
      {text: 'Geozone typen', href: '/settings/geo-zone-types', disabled: false},
      // {text: 'FLU0000001', disabled: true},      
    ])
    this.$store.dispatch(types.BACKGROUND_ICON, 'cogs');
  },  
  beforeDestroy(){
    this.$store.dispatch(types.BACKGROUND_ICON, null);
  }  
}
</script>
<style>
.dd-detail-list li{
  list-style-type: none;
  padding-bottom: 4px;
  padding-left: 4px;
  border-bottom: 1px solid black;
  background-color: blue-gey lighten-5;
}
</style>
